<template>
    <div>
        <base-header type="gradient-success" class="pb-7">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h1 class="d-inline-block mb-0">Fälle</h1>
<!--                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                        <route-bread-crumb></route-bread-crumb>
                    </nav>-->
                </div>
                <div class="col-lg-6 col-5 text-right">
                    <!--                    <base-button size="sm" type="neutral">New</base-button>
                                        <base-button size="sm" type="neutral">Filters</base-button>-->
                </div>
            </div>
            <div class="row">
                <div class="col-xl-4 col-md-6">
                    <IncidentsOpen title="Offene"></IncidentsOpen>
                </div>
                <div class="col-xl-4 col-md-6">
                    <IncidentsToday title="Heute fällig"></IncidentsToday>
                </div>
                <div class="col-xl-4 col-md-6">
                    <IncidentsClosed title="Geschlossene"></IncidentsClosed>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <!--Charts-->
            <div class="row">
                <div class="col mb-5 mb-xl-0">
                    <IncidentsTable :showOpenIncidents="showOpenIncidents" title="Incidents"></IncidentsTable>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import 'moment/locale/de';
import Card from '@/components/Cards/Card';
import IncidentsTable from '@/views/Tables/IncidentsTable';
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import IncidentsToday from "@/views/Widgets/IncidentsToday";
import IncidentsOpen from "@/views/Widgets/IncidentsOpen";
import IncidentsClosed from "@/views/Widgets/IncidentsClosed";
import { useRoute } from "vue-router"

export default {
    name: 'Incidents',
    components: {
        Card,
        IncidentsTable,
        IncidentsToday,
        IncidentsOpen,
        IncidentsClosed,
        RouteBreadCrumb,
    },
    data() {
        return {
            value: 1,
            totalIncidents: 1600,
            lastMontIncidents: -3.25,
            errorIncidents: 3.58,
            openIncidents: 6,
            deadIncidents: 2,
            closedIncidents: 114,
            todaysIncidents: 3,
            yesterdayIncidents: 4,
            showOpenIncidents: false,
        };
    },
    created() {
        this.showOpenIncidents = this.$route.query.showOpenIncidents === 'true' // must convert query string to bool
    }
};
</script>

